<template>
  <div v-if="visible" class="billing-overlay-mask">
    <div class="billing-overlay-card">
      <div v-if="billingConfirmation.phase === 'finalizing'">
        <div class="spinner" aria-hidden="true"></div>
        <p>{{ $t("billing.finalizing") }}</p>
        <!-- iOS checkout runs in the external default browser, which gives no
             abandon signal (no browserFinished) — a user who bailed out of
             checkout and app-switched back needs a way out of this overlay.
             Dismissing during a real payment loses only the celebratory
             redirect; the webhook still grants the entitlement reactively. -->
        <div class="billing-overlay-actions">
          <button class="btn btn-secondary" @click="dismiss">
            {{ $t("billing.finalizingCancel") }}
          </button>
        </div>
      </div>
      <div v-else-if="billingConfirmation.phase === 'timeout'">
        <p>{{ $t("billing.finalizingSlow") }}</p>
        <div class="billing-overlay-actions">
          <button class="btn btn-primary" @click="checkAgain">
            {{ $t("billing.checkAgain") }}
          </button>
          <button class="btn btn-secondary" @click="dismiss">
            {{ $t("common.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch } from "vue";
import { useRouter } from "vue-router";
import {
  billingConfirmation,
  startBillingWatch,
  stopBillingWatch,
  resetBillingConfirmation,
} from "@/composables/useBillingConfirmation.js";

export default {
  name: "BillingFinalizingOverlay",
  setup() {
    const router = useRouter();
    const visible = computed(() =>
      ["finalizing", "timeout"].includes(billingConfirmation.phase)
    );

    watch(
      () => billingConfirmation.phase,
      (phase) => {
        if (phase === "confirmed") {
          stopBillingWatch();
          router
            .push("/dashboard/account?checkoutSuccess=true")
            .finally(() => resetBillingConfirmation());
        }
      }
    );

    const checkAgain = () => startBillingWatch();
    const dismiss = () => resetBillingConfirmation();

    return { billingConfirmation, visible, checkAgain, dismiss };
  },
};
</script>

<style scoped>
.billing-overlay-mask {
  position: fixed;
  inset: 0;
  background: var(--al-scrim);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}
.billing-overlay-card {
  background: var(--al-surface-raised);
  border-radius: var(--al-radius-md);
  padding: 24px 28px;
  max-width: 320px;
  text-align: center;
}
.billing-overlay-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 12px;
}
.spinner {
  width: 32px;
  height: 32px;
  margin: 0 auto 12px;
  border: 3px solid var(--al-border);
  border-top-color: var(--al-primary);
  border-radius: 50%;
  animation: billing-spin 0.8s linear infinite;
}
@keyframes billing-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
